import { generateFromString } from 'generate-avatar'

export const ALL_OPTIONS = 0

export const ALL_STRING_OPTIONS = '0'

export function getRandomImageSrc(randomCharacters = 'default') {
  return `data:image/svg+xml;utf8,${generateFromString(randomCharacters)}`
}
